var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "forecastRunnerStatus" } },
    [
      _c(
        "div",
        {
          staticClass: "dongle",
          class: { show: _vm.showDongle },
          on: {
            click: function ($event) {
              return _vm.toggleLogView()
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                version: "1.1",
                viewBox: "0 0 130 134",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("g", { attrs: { fill: "#5C5B64" } }, [
                _c("path", {
                  attrs: {
                    d: "m97.4 0-32.789 18.903v7e-3l33.172 19.181-33.2 18.665v-8e-3l-0.026-0.015-0.024 37.153-32.172 18.547 32.749 18.871 64.867-37.466v-75.053zm-97.4 18.821v74.964l0.095 0.055 32.587-18.321 1e-3 -0.023-32.616-18.859 32.21-18.569-6e-3 -3e-3 0.024-37.848z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "m64.583 56.748v8e-3l33.2-18.665-33.172-19.181-0.024 37.84z",
                    opacity: ".5",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "m48.842 47.594v2e-3l15.713 9.085v1e-3l2e-3 -2e-3v0.053l0.026 0.015 0.025-37.84 3e-3 2e-3v-7e-3l-32.316-18.686-0.024 37.848 6e-3 3e-3 0.046-0.026z",
                    opacity: ".35",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "m64.557 56.733-3e-3 -2e-3 -31.851 18.777-0.427 36.876 0.085 0.049 32.172-18.547z",
                    opacity: ".7",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "m64.512 56.707-32.235-18.639-32.21 18.569 32.616 18.859v-0.026z",
                    opacity: ".6",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "m32.682 75.519-32.587 18.321l32.161 18.532 1e-3 -0.057 0.104 0.118z",
                    opacity: ".8",
                  },
                }),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "modelForecast",
          attrs: { title: "Forecasts", showRefreshButton: "" },
        },
        _vm._l(_vm.actives, function (item, index) {
          return _c("div", { staticClass: "item tile" }, [
            _c("header", [_vm._v(_vm._s(item.title))]),
            _vm._v(" "),
            _c("div", { staticClass: "text" }, [
              _c("div", {
                staticClass: "state",
                class: item.processStatusName.toLowerCase(),
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          " +
                    _vm._s(item.processStatusName) +
                    "\n          "
                ),
                _c(
                  "small",
                  {
                    attrs: {
                      title: _vm._f("moment")(item.updateDate, "DD/MM/YYYY"),
                    },
                  },
                  [
                    _vm._v(
                      "Modified:\n            " +
                        _vm._s(_vm.$moment.utc(item.updateDate).local().from())
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "outline",
                  on: {
                    click: function ($event) {
                      item.isOpen = !item.isOpen
                    },
                  },
                },
                [_vm._v("Logs")]
              ),
              _vm._v(" "),
              item.processStatus === 2
                ? _c(
                    "button",
                    {
                      staticClass: "outline",
                      on: {
                        click: function ($event) {
                          return _vm.onViewDataClick(item)
                        },
                      },
                    },
                    [_vm._v("View data")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.processStatus === 4
                ? _c(
                    "button",
                    {
                      staticClass: "outline",
                      on: {
                        click: function ($event) {
                          return _vm.onDownloadLogClick(item)
                        },
                      },
                    },
                    [_vm._v("Download log\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.processStatus === 3
                ? _c(
                    "button",
                    {
                      staticClass: "outline",
                      on: {
                        click: function ($event) {
                          return _vm.onStopClick(item, $event)
                        },
                      },
                    },
                    [_vm._v("Stop")]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "pre",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: item.isOpen,
                    expression: "item.isOpen",
                  },
                ],
                staticClass: "logview",
              },
              [
                _vm._l(item.logs, function (log) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("moment")(log.logDate, "HH:mm:ss")) +
                        ": " +
                        _vm._s(log.text)
                    ),
                    _c("br"),
                  ]
                }),
              ],
              2
            ),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }